module.exports = "<div id=\"dvMap\" style=\"width: 500px; height: 500px;float:right\">\n\n</div>\n    <textarea placeholder=\"Enter Area name to populate Latitude and Longitude\" name=\"address\" [(ngModel)]=\"locality\" id=\"locality\" ></textarea><br>\n\n"


//////////////////
// WEBPACK FOOTER
// C:/vtrackOneqlik/oneqlik_wetrack/src/app/spec-dev/spec-dev.component.html
// module id = ../../../../../src/app/spec-dev/spec-dev.component.html
// module chunks = main